import React, { memo } from 'react';
import {useState} from 'react';
import { Handle } from 'react-flow-renderer';
import DesignCard from './DesignCard';

import regular from '../img/regular.png'
import RegularIcon from '@material-ui/icons/Assistant';
// import RegularIcon from '@material-ui/icons/CallMadeTwoTone';

export default memo(({ data }) => {

  const designerIconStyle = {
    // backgroundImage:'linear-gradient(to bottom, #a1a1a1, royalblue)', color:'white', padding:'5px', borderRadius:'25px', marginLeft:'10px'
    padding:'0px', color:'royalblue', borderRadius:'20px', marginTop:'10px', marginLeft:'10px', marginRight:'10px'

  }




    // if (data.isGraphicalMode == undefined || data.isGraphicalMode == null || data.isGraphicalMode == false)
    return (
    <div className="designnode" >

      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img  draggable={false} src={regular} width='50' height='50'></img> */}
      <RegularIcon fontSize='medium' style={designerIconStyle} draggable={false}/>
      <DesignCard attributes={data.attributes} name={data.label}/>

      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
    </div>
  );



  return (
    <div>

      <Handle
        type="target"
        position="top"
        style={{ background: '#555' }}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
      {/* <img  draggable={false} src={regular} width='50' height='50'></img> */}
      <RegularIcon fontSize='large' style={designerIconStyle} draggable={false}/>
      <Handle
        type="source"
        position="bottom"
        id="b2"
        style={{ bottom: -5, top: 'auto', background: '#555' }}
      />
      <label>{data.label}</label>

    </div>
  );



});